export type TeacherSupplyMetrics = {
  coachCount: number;
  teacherDemandForecast: number;
};

export const teacherUndersupplyCellClassName = 'bg-[#FCE8E6] group-hover:bg-[#FCE8E6]';
export const teacherOversupplyCellClassName = 'bg-[#E6F4EA] group-hover:bg-[#E6F4EA]';

export function getTeacherSupplyHighlightClass(
  availableTeachers: number,
  teacherDemandForecast: number,
): string | undefined {
  if (teacherDemandForecast === 0 && availableTeachers === 0) {
    return undefined;
  }
  if (availableTeachers <= teacherDemandForecast) {
    return teacherUndersupplyCellClassName;
  }
  if (availableTeachers >= teacherDemandForecast * 2) {
    return teacherOversupplyCellClassName;
  }
  return undefined;
}
